module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main